import { cn } from '@gyym/ui'

export interface ContentProps {
  children?: React.ReactNode
  className?: string
  mt?: number
  gap?: number
}

export const Content = ({
  children,
  className,
  mt = 6,
  gap = 6,
}: ContentProps) => (
  <div
    className={cn('flex w-full flex-col', className)}
    style={{ marginTop: `${mt * 4}px`, gap: `${gap * 4}px` }}
  >
    {children}
  </div>
)
